import '../../../styles/skelton/project-card-skelton.scss';

const ProjectCardSkeleton = () => (
  <div className="project-card skeleton-1 ">
    <div className="project-card-body">
      <div className=" skeleton-icon" />
      <div className="project-card-text">
        <div className="skeleton-line skeleton-title" />
        <div className="skeleton-line skeleton-value" />
      </div>
    </div>
  </div>
);

export default ProjectCardSkeleton;
